import React from 'react'
import Button from '../../../../../components/Button'

const PaymentCards = ({ cards }) => {
  return (
    <div className="flex flex-col">
      <span className="text-gray-500 font-bold">Cardurile tale</span>
      <hr className="w-[60%] bg-over-ternary-background mt-1" />
      <div className="mt-8 flex flex-col gap-3 text-over-primary-background">
        {cards.map(card => {
          return (
            <div
              key={`card-${card.number}`}
              className="flex justify-between items-center max-w-full sm:max-w-[80%]"
            >
              <div className="flex gap-3 items-center">
                <div className="w-12 rounded h-7 bg-primary"></div>
                <div className="text-sm">{card.number}</div>
              </div>
              <Button className="bg-btn-primary h-7">Sterge</Button>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default PaymentCards
